<template>
  <div class="endetyslsadv">
    <div class="between">
      <sub-title class="yslsatitle" :text="titletext" />
      <div class="mo">更多>></div>
    </div>
    <div class="yslsalist">
      <div class="yslsaitem flex_start" v-for="item in xhnum" :key="item">
        <div class="cover">
          <img src="../../../assets/jpcol/smallrentou_sample.png" alt="" />
        </div>
        <div class="inf">
          <div class="name">王家政律师</div>
          <div class="tag">
            <span>刑事诉讼</span>
            <span>离婚案件</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  props: {
    titletext: {
      type: String,
      default: "优秀律师",
    },
    xhnum: {
      type: Number,
      default: 3,
    },
  },
};
</script>

<style lang="scss" scoped>
.endetyslsadv {
  padding: 22px 0 32px;
  .yslsatitle {
    margin-left: 12px;
    font-size: 20px;
    line-height: 20px;
  }
  .mo {
    font-size: 16px;
    color: #0465ea;
    cursor: pointer;
    margin-right: 20px;
  }
  .yslsalist {
    padding: 6px 15px 0 22px;
    .yslsaitem {
      margin-top: 30px;
      .cover {
        img {
          width: 84px;
          height: 84px;
        }
      }
      .inf {
        margin-left: 16px;
        .name {
          font-size: 18px;
          color: #333333;
          font-weight: bold;
        }
        .tag {
          font-size: 12px;
          margin-top: 15px;
          color: #3e8fff;
          span {
            padding: 1px 5px;
            border: 1px solid #3e8fff;
            border-radius: 5px;
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>